import { Navigate, Outlet } from 'react-router-dom';
import { useAuthRedirect } from '../../utils/hooks/useAuthRedirect';

const AuthGuard = () => {
  const redirectPath = useAuthRedirect();
  return redirectPath ? <Navigate to={redirectPath} replace /> : <Outlet />;
};

export default AuthGuard;